import { render, staticRenderFns } from "./CtrlOrderInquiry.vue?vue&type=template&id=48dcfa1f&scoped=true&"
import script from "./CtrlOrderInquiry.vue?vue&type=script&lang=ts&"
export * from "./CtrlOrderInquiry.vue?vue&type=script&lang=ts&"
import style0 from "./CtrlOrderInquiry.vue?vue&type=style&index=0&id=48dcfa1f&lang=scss&scoped=true&"
import style1 from "./CtrlOrderInquiry.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48dcfa1f",
  null
  
)

export default component.exports